<script>
  import { getConfig } from '@app/config';
  import { eventKeywordSetList, selectedEventKeywords, toggleSelectedEventKeyword } from '@store/keyword-store';
  import { locale, _ } from 'svelte-i18n';
  import EventKeywordListItem from '../dummy/EventKeywordListItem.svelte';

  export let onChange;
  export let onClick;

  const { ignoreKeywordIds, keywordIconClasses } = getConfig().modules.events.keywordSets;

  function onKeywordClick(keywordId) {
    toggleSelectedEventKeyword(keywordId);
    onClick();
  }

  function isSelected(keywordId, selectedKeywords) {
    return selectedKeywords.includes(keywordId);
  }
</script>

<div class="keyword-select" lang="{$locale}">
  <i class="event-list__content__filter-row__item__icon fa fa-bars"></i>
  <select name="keyword" on:change="{onChange}">
    {#if $eventKeywordSetList.data[0]}
      <option value="">{$_('common.choose_category')}</option>
      {#each $eventKeywordSetList.data.filter(ks => ks.usage ==='keyword') as keywordSet}
        {#each keywordSet.keywords.filter(k => !ignoreKeywordIds.includes(k.id)) as keyword}
          <option value="{keyword.id}" lang=" {keyword.name[$locale] ? $locale : 'fi'}">
            {keyword.name[$locale] ? keyword.name[$locale] : keyword.name.fi}
          </option>
        {/each}
      {/each}
    {/if}
  </select>
</div>

<div class="keyword-list" lang="{$locale}">
  {#if $eventKeywordSetList.data[0]}
    {#each $eventKeywordSetList.data.filter(ks => ks.usage ==='keyword') as keywordSet}
      {#each keywordSet.keywords.filter(k => !ignoreKeywordIds.includes(k.id)) as keyword}
        <EventKeywordListItem
          keyword="{keyword}"
          selected={isSelected(keyword.id, $selectedEventKeywords)}
          iconClass="{keywordIconClasses[keyword.id]}"
          onClick={onKeywordClick}
        />
      {/each}
    {/each}
  {/if}
</div>


<style></style>